import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import getCurrencySymbol from '../lib/currenyUtils';
import { Constants } from '../lib/const/constants';

const CURRENCY_NAMES = {
  GBP: 'British Pound',
  USD: 'US Dollar',
  EUR: 'Euro',
  AED: 'UAE Dirham',
  AUD: 'Australian Dollar',
  CAD: 'Canadian Dollar',
  INR: 'Indian Rupee',
  JPY: 'Japanese Yen',
  CHF: 'Swiss Franc',
  HKD: 'Hong Kong Dollar',
  SGD: 'Singapore Dollar',
  NZD: 'New Zealand Dollar',
  SEK: 'Swedish Krona',
  NOK: 'Norwegian Krone',
  DKK: 'Danish Krone',
  MYR: 'Malaysian Ringgit',
  RON: 'Romanian Leu',
  LKR: 'Srilankan Rupee',
};

const getAmountFontSize = (amountStr) => {
  const len = String(amountStr).length;
  if (len <= 8) return 24;
  if (len <= 11) return 22;
  if (len <= 14) return 18;
  return 13;
};

function WalletsSection({
  balances = [],
  usedBalances = {},
  accountNumber = '',
  sortcode = '',
  accountName = '',
  Iban = '',
  onAddWallet = () => { },
  sectionRequired = true,
}) {
  const scrollRef = useRef(null);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);

  const numberWithCommas = (x) =>
    x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');



  const reorderedBalances = [
    ...balances.filter((b) => b.currency === 'GBP'),
    ...balances.filter((b) => b.currency !== 'GBP'),
  ];

  console.log("check", reorderedBalances);

  const checkScrollButtons = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 1);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  useEffect(() => {
    checkScrollButtons();
    const el = scrollRef.current;
    if (el) {
      el.addEventListener('scroll', checkScrollButtons);
      window.addEventListener('resize', checkScrollButtons);
    }
    return () => {
      if (el) el.removeEventListener('scroll', checkScrollButtons);
      window.removeEventListener('resize', checkScrollButtons);
    };
  }, [balances]);

  const scroll = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({ left: direction === 'left' ? -260 : 260, behavior: 'smooth' });
    setTimeout(checkScrollButtons, 350);
  };

  const arrowButtonStyle = {
    flexShrink: 0,
    width: 16,
    height: 24,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#9ca3af',
    fontSize: 22,
    padding: 0,
    lineHeight: 1,
  };

  return (
    <div style={{ margin: '0 0 24px 0', display: 'flex', alignItems: 'center', gap: 4 }}>

      <button
        onClick={() => scroll('left')}
        style={{
          ...arrowButtonStyle,
          opacity: canScrollLeft ? 1 : 0,
          pointerEvents: canScrollLeft ? 'auto' : 'none',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.color = '#EB640A'; }}
        onMouseLeave={(e) => { e.currentTarget.style.color = '#4e4f52'; }}
        aria-label="Scroll left"
      >
        ‹
      </button>

      <div style={{ position: 'relative', flex: 1, minWidth: 0, overflow: 'hidden' }}>

        {canScrollRight && (
          <div
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
              bottom: 8,
              width: 40,
              background: 'linear-gradient(to left, #f5f6fa 30%, transparent)',
              zIndex: 2,
              pointerEvents: 'none',
            }}
          />
        )}

        <div
          ref={scrollRef}
          style={{
            display: 'flex',
            overflowX: 'auto',
            gap: 16,
            paddingBottom: 8,
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            alignItems: 'center',
          }}
        >

          {reorderedBalances.map((resp, index) => {
            const flagUrl = (() => {
              switch (resp.currency) {
                case 'EUR': return `${Constants.FXMASTER_BASE_URL}flags/eu.png`;
                case 'RON': return `${Constants.FXMASTER_BASE_URL}flags/ro.png`;
                case 'DKK': return `${Constants.FXMASTER_BASE_URL}flags/dk.png`;
                case 'NOK': return `${Constants.FXMASTER_BASE_URL}flags/no.png`;
                case 'SEK': return `${Constants.FXMASTER_BASE_URL}flags/se.png`;
                case 'MYR': return `${Constants.FXMASTER_BASE_URL}flags/my.png`;
                default: return `${Constants.FXMASTER_BASE_URL}flags/${resp?.meta?.flag?.split('/').pop()}`;
              }
            })();

            const data = {
              currency: resp.currency,
              balance:
                resp.currency != null &&
                Object.prototype.hasOwnProperty.call(usedBalances, resp.currency)
                  ? numberWithCommas(
                      parseFloat(
                        resp.balance - usedBalances[resp.currency] < 0
                          ? '0'
                          : resp.balance - usedBalances[resp.currency],
                      ).toFixed(2),
                    )
                  : numberWithCommas(parseFloat(resp.balance).toFixed(2)),
              flag: flagUrl,
              currencyid: resp.meta?.country_id,
              accountNumber,
              sortcode,
              accountName,
              Iban
            };

            const availableDisplay =
              resp.currency != null &&
              Object.prototype.hasOwnProperty.call(usedBalances, resp.currency)
                ? numberWithCommas(
                    parseFloat(
                      resp.balance - usedBalances[resp.currency] <= 0
                        ? 0
                        : resp.balance - usedBalances[resp.currency],
                    ).toFixed(2),
                  )
                : resp.balance && parseFloat(resp.balance) > 0
                ? numberWithCommas(parseFloat(resp.balance).toFixed(2))
                : '0';


            // const availableDisplay =
            //   resp.currency != null &&
            //     Object.prototype.hasOwnProperty.call(usedBalances, resp.currency)
            //     ? formatAmount(
            //       resp.balance - usedBalances[resp.currency] <= 0
            //         ? 0
            //         : resp.balance - usedBalances[resp.currency]
            //     )
            //     : resp.balance && parseFloat(resp.balance) > 0
            //       ? formatAmount(resp.balance)
            //       : '0';


            const amountFontSize = getAmountFontSize(
              `${getCurrencySymbol(resp.currency)}${availableDisplay}`
            );

            return (
              <Link
                to="/currencyDashboard"
                state={{ params: { data } }}
                key={index}
                style={{ textDecoration: 'none', flexShrink: 0 }}
              >
                <div
                  className={`
                    w-[270px] h-[172px]
                    p-6
                    rounded-2xl
                    border
                    cursor-pointer
                    box-border
                    transition-all duration-200
                    shadow-[0px_3px_6px_-4px_rgba(229,231,235,0.5),0px_8px_16px_-3px_rgba(229,231,235,0.5)]
                    hover:shadow-[0px_4px_16px_rgba(0,0,0,0.1)]
                    hover:-translate-y-[2px]
                    ${sectionRequired
                      ? 'bg-white border-[#E5E7EB]'
                      : 'bg-[rgba(255,255,255,0.9)] border-[#E5E7EB80]'
                    }
                  `}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
                    <div
                      className="
                        w-12 h-12
                        rounded-full
                        overflow-hidden
                        flex items-center justify-center
                        flex-shrink-0
                        border border-[#e8e8e8]
                        bg-gradient-to-br from-[#F3F4F6] to-[rgba(229,231,235,0.5)]
                      "
                    >
                      {data.flag && (
                        <img
                          src={data.flag}
                          alt={`${resp.currency} flag`}
                          style={{ width: '24px', height: '16px', objectFit: 'cover' }}
                        />
                      )}
                    </div>
                    <span style={{ fontWeight: 600, fontSize: 16, color: '#203358', letterSpacing: '0px', lineHeight: '24px' }}>
                      {resp.currency}
                    </span>
                  </div>

                  <div
                    style={{
                      fontSize: amountFontSize,
                      fontWeight: 600,
                      color: '#1D2338',
                      lineHeight: '36px',
                      letterSpacing: '0px',
                      fontStyle: 'semi-bold',
                      wordBreak: 'break-all',
                    }}
                  >
                    {getCurrencySymbol(resp.currency)}{availableDisplay}
                  </div>

                  <div style={{ fontSize: 14, color: '#676F7D', fontWeight: 400, lineHeight: '20px', letterSpacing: '0px' }}>
                    {CURRENCY_NAMES[resp.currency] || resp.currency}
                  </div>
                </div>
              </Link>
            );
          })}

          <div
            onClick={onAddWallet}
            className="
              w-[190px] h-[172px]
              flex-shrink-0
              flex flex-col items-center justify-center
              gap-4
              p-6
              rounded-2xl
              cursor-pointer
              bg-white
              border border-[#E5E7EB]
              shadow-[0px_4px_6px_-4px_rgba(229,231,235,0.5),0px_10px_15px_-3px_rgba(229,231,235,0.5)]
              transition-all duration-200
              hover:border-[#EB640A]
              hover:bg-[#fff8f5]
            "
          >
            <span style={{ fontSize: 28, color: '#D26521', fontWeight: 300, lineHeight: 1 }}>+</span>
            <span style={{ fontSize: 18, fontWeight: 600, color: '#203358', textAlign: 'center' }}>
              Add Wallet
            </span>
          </div>

        </div>
      </div>

      <button
        onClick={() => scroll('right')}
        style={{
          ...arrowButtonStyle,
          opacity: canScrollRight ? 1 : 0,
          pointerEvents: canScrollRight ? 'auto' : 'none',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.color = '#EB640A'; }}
        onMouseLeave={(e) => { e.currentTarget.style.color = '#4e4f52'; }}
        aria-label="Scroll right"
      >
        ›
      </button>

    </div>
  );
}

WalletsSection.propTypes = {
  balances: PropTypes.array.isRequired,
  usedBalances: PropTypes.object.isRequired,
  accountNumber: PropTypes.string,
  sortcode: PropTypes.string,
  Iban:PropTypes.String,
  accountName: PropTypes.string,
  onAddWallet: PropTypes.func,
  sectionRequired: PropTypes.bool,
};

export default WalletsSection;